(function () {
  'use strict';

  var CARD_SELECTOR = '[data-fq-personalization]';
  var LIST_SELECTOR = '[data-fq-personalization-items]';
  var FALLBACK_ITEMS = ['ton prénom', 'ta photo', 'ta date'];
  var MAX_ITEMS = 4;

  var ICON_URLS = {
    photo: 'https://cdn.shopify.com/s/files/1/0897/0308/8457/files/EMOTICONNE_CAMERA.webp?v=1783767811',
    text: 'https://cdn.shopify.com/s/files/1/0897/0308/8457/files/EMOTICONNE_TEXTE.webp?v=1783767811',
    date: 'https://cdn.shopify.com/s/files/1/0897/0308/8457/files/EMOTICONNE_DATE.webp?v=1783767811'
  };

  function getIconType(item) {
    var key = normalizeKey(item);
    if (
      key.indexOf('photo') !== -1 ||
      key.indexOf('image') !== -1 ||
      key.indexOf('fichier') !== -1 ||
      key.indexOf('upload') !== -1 ||
      key.indexOf('camera') !== -1
    ) {
      return 'photo';
    }
    if (
      key.indexOf('date') !== -1 ||
      key.indexOf('annee') !== -1 ||
      key.indexOf('year') !== -1 ||
      key.indexOf('jour') !== -1
    ) {
      return 'date';
    }
    return 'text';
  }

  function buildIconItem(item) {
    var type = getIconType(item);
    var span = document.createElement('span');
    span.className = 'fq-card-personalization__item fq-card-personalization__item--' + type;
    var img = document.createElement('img');
    img.src = ICON_URLS[type];
    img.alt = ''; // émojis décoratifs (a11y)
    img.width = 32;
    img.height = 32;
    img.loading = 'lazy';
    span.appendChild(img);
    return span;
  }

  var CACHE = new Map();
  var PENDING = new Map();

  var BLACKLIST = new Set([
    'personnalisation',
    'personalisation',
    'personnalisation du produit',
    'personalisation du produit',
    'personnaliser',
    'options',
    'option',
    'choisir',
    'choisir une option',
    'choisir vos options',
    'select options',
    'quantity',
    'quantite',
    'taille',
    'size',
    'couleur',
    'color',
    'prix',
    'price',
    'ajouter au panier',
    'add to cart',
    'acheter',
    'buy now'
  ]);

  function stripAccents(value) {
    if (!value) return '';
    if (typeof value.normalize !== 'function') return value;
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function normalizeKey(value) {
    return stripAccents(String(value || ''))
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function cleanLabel(value) {
    var text = String(value || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .replace(/[\u2022\u00b7]/g, ' ')
      .trim();

    if (!text) return '';

    text = text.replace(/\s*:\s*$/, '').trim();

    var key = normalizeKey(text);
    if (!key || key.length < 2) return '';
    if (BLACKLIST.has(key)) return '';
    if (text.length > 60) return '';

    if (
      key.indexOf('variante epuisee') !== -1 ||
      key.indexOf('indisponible') !== -1 ||
      key.indexOf('sold out') !== -1
    ) {
      return '';
    }

    if (/^(option|field|champ)$/i.test(text)) return '';

    return text;
  }

  function dedupeAndLimit(items) {
    var output = [];
    var seen = new Set();

    items.forEach(function (item) {
      var cleaned = cleanLabel(item);
      if (!cleaned) return;

      var key = normalizeKey(cleaned);
      if (!key || seen.has(key)) return;

      seen.add(key);
      output.push(cleaned);
    });

    return output.slice(0, MAX_ITEMS);
  }

  function parsePropertyLabelFromName(name) {
    var match = String(name || '').match(/properties\[(.*?)\]/i);
    if (!match || !match[1]) return '';
    return cleanLabel(match[1]);
  }

  function collectLabelsFromRoot(root, bucket) {
    if (!root) return;

    root
      .querySelectorAll(
        "input[name*='properties['], textarea[name*='properties['], select[name*='properties['], input[type='file']"
      )
      .forEach(function (field) {
        var fromName = parsePropertyLabelFromName(field.getAttribute('name'));
        if (fromName) bucket.push(fromName);

        var id = field.getAttribute('id');
        if (id) {
          var relatedLabel = root.querySelector("label[for='" + id + "']");
          if (relatedLabel) {
            var fromFor = cleanLabel(relatedLabel.textContent);
            if (fromFor) bucket.push(fromFor);
          }
        }

        var wrappedLabel = field.closest('label');
        if (wrappedLabel) {
          var fromWrap = cleanLabel(wrappedLabel.textContent);
          if (fromWrap) bucket.push(fromWrap);
        }
      });
  }

  var UPLOAD_LIFT_LABEL_SELECTORS = [
    '.cl-upload--label',
    "[class*='cl-upload'] label",
    "[class*='upload-lift'] label",
    "[class*='uploadlift'] label"
  ].join(',');

  var OTHER_APP_LABEL_SELECTORS = [
    "[class*='qkf'] label",
    "[class*='qikify'] label",
    "[class*='tepo'] label"
  ].join(',');

  function collectAppLabelsDirect(doc, bucket) {
    doc.querySelectorAll(UPLOAD_LIFT_LABEL_SELECTORS).forEach(function (label) {
      var text = String(label.textContent || '').trim();
      var key = normalizeKey(text);
      var isFileLabel =
        key.indexOf('fichier') !== -1 ||
        key.indexOf('upload') !== -1 ||
        key.indexOf('image') !== -1 ||
        key.indexOf('photo') !== -1 ||
        key.indexOf('telecharg') !== -1;

      if (isFileLabel) {
        bucket.push('votre image');
      } else {
        var cleaned = cleanLabel(text);
        if (cleaned) bucket.push(cleaned);
      }
    });

    doc.querySelectorAll(OTHER_APP_LABEL_SELECTORS).forEach(function (label) {
      var cleaned = cleanLabel(label.textContent);
      if (cleaned) bucket.push(cleaned);
    });
  }

  function extractFieldsFromProductDoc(doc) {
    var raw = [];

    collectAppLabelsDirect(doc, raw);

    if (!raw.length) {
      var appRoots = doc.querySelectorAll(
        "[class*='tepo'], [id*='tepo'], [class*='upload-lift'], [id*='upload-lift'], [data-tepo], [data-upload-lift], [class*='uploadlift'], [id*='uploadlift'], [class*='cl-upload'], [class*='qkf'], [class*='qikify']"
      );

      if (appRoots.length) {
        appRoots.forEach(function (root) {
          collectLabelsFromRoot(root, raw);
        });
      }

      var forms = doc.querySelectorAll("form[action*='/cart/add']");
      if (forms.length) {
        forms.forEach(function (form) {
          collectLabelsFromRoot(form, raw);
        });
      }

      if (!raw.length) {
        collectLabelsFromRoot(doc, raw);
      }
    }

    return dedupeAndLimit(raw);
  }

  function renderItems(listEl, items) {
    if (!listEl) return;

    listEl.innerHTML = '';

    var displayItems = items && items.length ? items : FALLBACK_ITEMS;

    displayItems.forEach(function (item, index) {
      if (index > 0) {
        var sep = document.createElement('span');
        sep.className = 'fq-card-personalization__sep';
        sep.textContent = '+';
        listEl.appendChild(sep);
      }
      listEl.appendChild(buildIconItem(item));
    });
  }

  function needsDetection(card) {
    return !!card && card.classList.contains('is-loading');
  }

  function normalizeProductUrl(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.pathname + parsed.search;
    } catch (error) {
      return url;
    }
  }

  function fetchItemsForProduct(url) {
    var normalizedUrl = normalizeProductUrl(url);

    if (CACHE.has(normalizedUrl)) {
      return Promise.resolve(CACHE.get(normalizedUrl));
    }

    if (PENDING.has(normalizedUrl)) {
      return PENDING.get(normalizedUrl);
    }

    var request = fetch(normalizedUrl, {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var items = extractFieldsFromProductDoc(doc);
        CACHE.set(normalizedUrl, items);
        return items;
      })
      .catch(function () {
        CACHE.set(normalizedUrl, []);
        return [];
      })
      .finally(function () {
        PENDING.delete(normalizedUrl);
      });

    PENDING.set(normalizedUrl, request);

    return request;
  }

  function hydrateCard(card) {
    if (!card || card.dataset.fqPersonalizationReady === '1') return;

    var listEl = card.querySelector(LIST_SELECTOR);
    if (!listEl) return;

    if (!needsDetection(card)) {
      card.dataset.fqPersonalizationReady = '1';
      return;
    }

    if (card.dataset.fqPersonalizationLoading === '1') return;

    var productUrl = card.getAttribute('data-product-url');
    if (!productUrl) {
      card.classList.remove('is-loading');
      card.dataset.fqPersonalizationReady = '1';
      return;
    }

    card.dataset.fqPersonalizationLoading = '1';

    fetchItemsForProduct(productUrl)
      .then(function (items) {
        renderItems(listEl, items);
      })
      .finally(function () {
        card.classList.remove('is-loading');
        card.dataset.fqPersonalizationReady = '1';
        card.dataset.fqPersonalizationLoading = '0';
      });
  }

  var VIEWPORT_OBSERVER = null;

  function getViewportObserver() {
    if (VIEWPORT_OBSERVER || !('IntersectionObserver' in window)) return VIEWPORT_OBSERVER;
    VIEWPORT_OBSERVER = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            obs.unobserve(entry.target);
            hydrateCard(entry.target);
          }
        });
      },
      { rootMargin: '200px 0px' }
    );
    return VIEWPORT_OBSERVER;
  }

  // Les cartes déjà rendues côté serveur (sans classe is-loading) n'ont besoin
  // d'aucun téléchargement : on les marque prêtes tout de suite. Les cartes à
  // détecter ne déclenchent leur fetch QUE lorsqu'elles approchent du viewport
  // -> aucune requête réseau pour les cartes hors écran (perf / Core Web Vitals).
  function observeCard(card) {
    if (!card || card.dataset.fqPersonalizationReady === '1' || card.dataset.fqObserved === '1') {
      return;
    }
    if (!needsDetection(card)) {
      hydrateCard(card);
      return;
    }
    var observer = getViewportObserver();
    if (!observer) {
      hydrateCard(card);
      return;
    }
    card.dataset.fqObserved = '1';
    observer.observe(card);
  }

  function initPersonalizationCards(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll(CARD_SELECTOR).forEach(observeCard);
  }

  function setupObserver() {
    if (!('MutationObserver' in window)) return;

    var observer = new MutationObserver(function (mutations) {
      var shouldRefresh = false;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (shouldRefresh || node.nodeType !== 1) return;

          if (
            (node.matches && node.matches(CARD_SELECTOR)) ||
            (node.querySelector && node.querySelector(CARD_SELECTOR))
          ) {
            shouldRefresh = true;
          }
        });
      });

      if (shouldRefresh) {
        requestAnimationFrame(function () {
          initPersonalizationCards(document);
        });
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function bootstrap() {
    initPersonalizationCards(document);
    setupObserver();

    document.addEventListener('shopify:section:load', function (event) {
      initPersonalizationCards(event.target || document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
